import React from 'react'

const Footer = () => (
  <div
    className="lps"
    dangerouslySetInnerHTML={{__html: footerString}}
  >
  </div>
)

export default Footer

const footerString = `
<footer class="row clearfix">
        <div class="grid_6">
            <address>Lab Procurement Services LLC © 2019 | All Rights Reserved</address>
        </div>
        <div class="grid_6">
            <a href="https://www.labproservices.com/terms-and-conditions" style="float:right;">Terms and Conditions</a>        </div>
    </footer>
`
